var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingCircle2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 628,
    height: 317,
    viewBox: "0 0 628 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_27_469502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.673,
    cy: 313.999,
    r: 251.324,
    transform: "rotate(180 375.673 313.999)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.673,
    cy: 313.999,
    r: 251.324,
    transform: "rotate(180 375.673 313.999)",
    fill: "url(#paint0_linear_27_469502)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.673,
    cy: 313.999,
    r: 251.324,
    transform: "rotate(180 375.673 313.999)",
    fill: "url(#paint1_radial_27_469502)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 375.673,
    cy: 313.999,
    r: 251.574,
    transform: "rotate(180 375.673 313.999)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_27_469502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 252.324,
    cy: 314.003,
    r: 251.324,
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.324,
    cy: 314.003,
    r: 251.324,
    fill: "url(#paint2_linear_27_469502)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.324,
    cy: 314.003,
    r: 251.324,
    fill: "url(#paint3_radial_27_469502)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 252.324,
    cy: 314.003,
    r: 251.574,
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_27_469502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 375.676,
    r: 251.324,
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 375.676,
    r: 251.324,
    fill: "url(#paint4_linear_27_469502)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 375.676,
    r: 251.324,
    fill: "url(#paint5_radial_27_469502)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 375.676,
    r: 251.574,
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_27_469502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 252.325,
    r: 251.324,
    transform: "rotate(180 313.999 252.325)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 252.325,
    r: 251.324,
    transform: "rotate(180 313.999 252.325)",
    fill: "url(#paint6_radial_27_469502)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 252.325,
    r: 251.324,
    transform: "rotate(180 313.999 252.325)",
    fill: "url(#paint7_linear_27_469502)",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 313.999,
    cy: 252.325,
    r: 251.574,
    transform: "rotate(180 313.999 252.325)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_27_469502",
    x: 123.849,
    y: 62.1749,
    width: 503.649,
    height: 503.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_27_469502"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27_469502"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_27_469502",
    x: 0.49942,
    y: 62.1784,
    width: 503.649,
    height: 503.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_27_469502"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27_469502"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_27_469502",
    x: 62.1741,
    y: 123.852,
    width: 503.649,
    height: 503.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_27_469502"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27_469502"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_27_469502",
    x: 62.1741,
    y: 0.500015,
    width: 503.649,
    height: 503.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_27_469502"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27_469502"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_469502",
    x1: 840.777,
    y1: 115.462,
    x2: 361.289,
    y2: 205.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_469502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(556.82 314.986) rotate(-180) scale(492.705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842199,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_469502",
    x1: -365.32,
    y1: 397.928,
    x2: 188.556,
    y2: 613.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518602,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27_469502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(252.324 314.003) rotate(179.827) scale(326.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_469502",
    x1: 779.102,
    y1: 177.139,
    x2: 299.614,
    y2: 267.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27_469502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.615 400.89) rotate(21.7389) scale(503.853 571.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224735,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37505,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66121,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783675,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_27_469502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.748 190.648) rotate(137.992) scale(401.306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27_469502",
    x1: 779.102,
    y1: 53.7876,
    x2: 299.614,
    y2: 143.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingCircle2);
export default __webpack_public_path__ + "static/media/setting-circle-2.bff567ba9d1661af7c75c2731c0596c6.svg";
export { ForwardRef as ReactComponent };